module.exports = __webpack_public_path__ + "img/trash.05bc55c1.svg";